package org.solyton.solawi.bid.module.shares.`data`.management

import kotlin.Int
import kotlin.collections.List
import org.evoleq.axioms.definition.ReadOnly
import org.evoleq.axioms.definition.ReadWrite
import org.evoleq.compose.modal.Modals
import org.evoleq.device.`data`.Device
import org.evoleq.optics.lens.Lens
import org.evoleq.optics.storage.ActionDispatcher
import org.solyton.solawi.bid.module.context.`data`.Context
import org.solyton.solawi.bid.module.i18n.`data`.Environment
import org.solyton.solawi.bid.module.i18n.`data`.I18N
import org.solyton.solawi.bid.module.shares.`data`.history.ShareSubscriptionStatusHistories
import org.solyton.solawi.bid.module.shares.`data`.offers.ShareOffer
import org.solyton.solawi.bid.module.shares.`data`.subscriptions.ShareSubscription
import org.solyton.solawi.bid.module.shares.`data`.types.ShareType

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareManagement.context]
 */
@ReadWrite
public val context: Lens<ShareManagement, Context> by lazy {
      Lens(
        get = { whole -> whole.context },
        set = { part -> { whole -> whole.copy(context = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareManagement.context]
 */
@ReadWrite
public fun ShareManagement.context(`set`: Context.() -> Context): ShareManagement = copy(context =
    set(context))

/**
 * Autogenerated ReadOnly Lens.
 * Read [ShareManagement.actions]
 */
@ReadOnly
public val actions: Lens<ShareManagement, ActionDispatcher<ShareManagement>> by lazy {
      Lens(
        get = { whole -> whole.actions },
        set = { { it } }
      )}


/**
 * Autogenerated ReadOnly Lens.
 * Read [ShareManagement.environment]
 */
@ReadOnly
public val environment: Lens<ShareManagement, Environment> by lazy {
      Lens(
        get = { whole -> whole.environment },
        set = { { it } }
      )}


/**
 * Autogenerated Lens.
 * Read and manipulate [ShareManagement.deviceData]
 */
@ReadWrite
public val deviceData: Lens<ShareManagement, Device> by lazy {
      Lens(
        get = { whole -> whole.deviceData },
        set = { part -> { whole -> whole.copy(deviceData = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareManagement.deviceData]
 */
@ReadWrite
public fun ShareManagement.deviceData(`set`: Device.() -> Device): ShareManagement = copy(deviceData
    = set(deviceData))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareManagement.modals]
 */
@ReadWrite
public val modals: Lens<ShareManagement, Modals<Int>> by lazy {
      Lens(
        get = { whole -> whole.modals },
        set = { part -> { whole -> whole.copy(modals = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareManagement.modals]
 */
@ReadWrite
public fun ShareManagement.modals(`set`: Modals<Int>.() -> Modals<Int>): ShareManagement =
    copy(modals = set(modals))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareManagement.i18n]
 */
@ReadWrite
public val i18n: Lens<ShareManagement, I18N> by lazy {
      Lens(
        get = { whole -> whole.i18n },
        set = { part -> { whole -> whole.copy(i18n = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareManagement.i18n]
 */
@ReadWrite
public fun ShareManagement.i18n(`set`: I18N.() -> I18N): ShareManagement = copy(i18n = set(i18n))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareManagement.shareSubscriptions]
 */
@ReadWrite
public val shareSubscriptions: Lens<ShareManagement, List<ShareSubscription>> by lazy {
      Lens(
        get = { whole -> whole.shareSubscriptions },
        set = { part -> { whole -> whole.copy(shareSubscriptions = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareManagement.shareSubscriptions]
 */
@ReadWrite
public
    fun ShareManagement.shareSubscriptions(`set`: List<ShareSubscription>.() -> List<ShareSubscription>):
    ShareManagement = copy(shareSubscriptions = set(shareSubscriptions))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareManagement.shareOffers]
 */
@ReadWrite
public val shareOffers: Lens<ShareManagement, List<ShareOffer>> by lazy {
      Lens(
        get = { whole -> whole.shareOffers },
        set = { part -> { whole -> whole.copy(shareOffers = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareManagement.shareOffers]
 */
@ReadWrite
public fun ShareManagement.shareOffers(`set`: List<ShareOffer>.() -> List<ShareOffer>):
    ShareManagement = copy(shareOffers = set(shareOffers))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareManagement.shareTypes]
 */
@ReadWrite
public val shareTypes: Lens<ShareManagement, List<ShareType>> by lazy {
      Lens(
        get = { whole -> whole.shareTypes },
        set = { part -> { whole -> whole.copy(shareTypes = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareManagement.shareTypes]
 */
@ReadWrite
public fun ShareManagement.shareTypes(`set`: List<ShareType>.() -> List<ShareType>): ShareManagement
    = copy(shareTypes = set(shareTypes))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareManagement.personalShareSubscriptions]
 */
@ReadWrite
public val personalShareSubscriptions: Lens<ShareManagement, List<ShareSubscription>> by lazy {
      Lens(
        get = { whole -> whole.personalShareSubscriptions },
        set = { part -> { whole -> whole.copy(personalShareSubscriptions = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareManagement.personalShareSubscriptions]
 */
@ReadWrite
public
    fun ShareManagement.personalShareSubscriptions(`set`: List<ShareSubscription>.() -> List<ShareSubscription>):
    ShareManagement = copy(personalShareSubscriptions = set(personalShareSubscriptions))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareManagement.personalShareOffers]
 */
@ReadWrite
public val personalShareOffers: Lens<ShareManagement, List<ShareOffer>> by lazy {
      Lens(
        get = { whole -> whole.personalShareOffers },
        set = { part -> { whole -> whole.copy(personalShareOffers = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareManagement.personalShareOffers]
 */
@ReadWrite
public fun ShareManagement.personalShareOffers(`set`: List<ShareOffer>.() -> List<ShareOffer>):
    ShareManagement = copy(personalShareOffers = set(personalShareOffers))

/**
 * Autogenerated Lens.
 * Read and manipulate [ShareManagement.shareSubscriptionStatusHistories]
 */
@ReadWrite
public val shareSubscriptionStatusHistories: Lens<ShareManagement, ShareSubscriptionStatusHistories>
    by lazy {
      Lens(
        get = { whole -> whole.shareSubscriptionStatusHistories },
        set = { part -> { whole -> whole.copy(shareSubscriptionStatusHistories = part) } }
      )}


/**
 * Autogenerated Setter of a Pseudo Lens
 * Manipulate [ShareManagement.shareSubscriptionStatusHistories]
 */
@ReadWrite
public
    fun ShareManagement.shareSubscriptionStatusHistories(`set`: ShareSubscriptionStatusHistories.() -> ShareSubscriptionStatusHistories):
    ShareManagement = copy(shareSubscriptionStatusHistories = set(shareSubscriptionStatusHistories))
